/**
 * Keys added in newer builds that must appear in Users → Permissions even if
 * GET /api/permissions was cached from an older API or the server is mid-deploy.
 * Keep labels aligned with server utils/permissions.js PERMISSION_LABELS.
 */
export const PERMISSION_METADATA_FALLBACK: { key: string; label: string }[] = [
  { key: 'retain_iq', label: 'RetainIQ (call logs & scripts)' },
  { key: 'retain_iq_reports', label: 'RetainIQ reports & script library (admin)' },
  { key: 'manage_credit_card_services', label: 'Credit Card Services' },
];
